import React from "react";
import jsPDF from "jspdf";
// eslint-disable-next-line
import lodashGet from "lodash/get";
// import { format } from "date-fns";
import canvg from "canvg";
import QRCode from "react-qr-code";
import JsBarcode from "jsbarcode";
import ReactDOMServer from "react-dom/server";

import { getDistinctObjectValues, getDistinctValues, isEmpty, isFalse, isTrue, listFromCsv } from "../../../utils/helpers";
import { setDefault, minReqHeight, totalPagesExp, addTable } from "../../../helpers/pdfHelper";
import { getCutOrderFlowInfoList } from "../../../helpers/orderHelper";
import { BundleSheetType } from "../../../constants";

const barcodeOptions = { fontSize: 30 };
const defTitleStyle = { fontSize: 7, fontFamily: "Courier", fontWeight: "bold" };
const defValueStyle = { fontSize: 7, fontFamily: "times", fontWeight: "normal" };
const getText = (value, charLength = 20) => (!isEmpty(value) ? multiLineText(`${value}`, charLength) : "");

// TODO: For now show full serial number everywhere
export const finalSerialNo = (serialNo, resetDigits = 100) => {
  return serialNo;
  // if (isEmpty(serialNo)) return serialNo;
  // const baseValue = Math.pow(10, Number(resetDigits));
  // return serialNo % baseValue;
};

export const printBundlePlan = ({
  order,
  cutOrderList,
  bundleOrderList,
  layList,
  bundleList,
  tenant,
  flowInfoFields = [],
  orderFields = [],
  bundleExportFields = [],
  i18nMessages,
  resetDigits,
  type = "compact",
  unit = {}
}) => {
  if (
    isEmpty(order) ||
    isEmpty(bundleOrderList) ||
    isEmpty(layList) ||
    isEmpty(bundleList) ||
    isEmpty(orderFields) ||
    isEmpty(flowInfoFields) ||
    isEmpty(i18nMessages)
  ) {
    return;
  }

  var doc = new jsPDF();

  const suffix = ``;
  const heading = `BUNDLE PLAN ${suffix}`;
  const filename = `${heading}.pdf`;

  setDefault(doc, "BUNDLE PLAN", tenant, null, unit);
  doc.setFontSize(10);
  const pageHeight = doc.internal.pageSize.getHeight();
  let startY = 24;

  const tableWidth = doc.internal.pageSize.getWidth() - 14;

  let addNewPage = false;
  bundleOrderList
    .sort((a, b) => a.serialNo - b.serialNo)
    .forEach(bundleOrder => {
      const currBundleList = bundleList.filter(b => b.bundleOrderId === bundleOrder.id).map(b => ({ ...b, rollSerials: JSON.parse(b.rollSerials) }));
      if (!isEmpty(currBundleList)) {
        const boSizeBreakupList = bundleOrder.boSizeBreakupList?.sort((a, b) => a.serialNo - b.serialNo) || [];
        const sizeKeyList = boSizeBreakupList.map(sb => sb.sizeKey);

        const columnsBundleOrder = [
          { dataKey: "info", header: "Info" },
          ...boSizeBreakupList.map(sb => ({ dataKey: sb.sizeKey, header: sb.size })), // TODO: Handle Size Group
          { dataKey: "total", header: "Total" }
        ];

        const bundlingQty = getDistinctObjectValues(boSizeBreakupList)?.reduce((acc, sb) => acc + sb.qty, 0);
        const bundlingQtyMap = getDistinctObjectValues(boSizeBreakupList)?.reduce(
          (acc, sb) => ({ ...acc, [sb.sizeKey]: (acc[sb.sizeKey] || 0) + sb.qty }),
          {}
        );

        const bundleQtyMap = sizeKeyList.reduce((acc, sizeKey) => {
          const qty = currBundleList.filter(b => b.sizeKey === sizeKey).reduce((acc, b) => acc + b.qty, 0);
          return { ...acc, [sizeKey]: qty };
        }, {});
        const bundleQty = Object.values(bundleQtyMap).reduce((acc, qty) => acc + qty, 0);

        const balanceQtyMap = sizeKeyList.reduce((acc, sizeKey) => {
          return { ...acc, [sizeKey]: (bundlingQtyMap[sizeKey] || 0) - (bundleQtyMap[sizeKey] || 0) };
        }, {});
        const balanceQty = Object.values(balanceQtyMap).reduce((acc, qty) => acc + qty, 0);

        const rowsBundleOrder = [
          { info: "Bundle Required Qty", total: bundlingQty, ...bundlingQtyMap },
          { info: "Bundle Completed Qty", total: bundleQty, ...bundleQtyMap },
          { info: "Balance Qty", total: balanceQty, ...balanceQtyMap }
        ];

        //** Print Order Info for second Bundle Order ownwards in new Page */
        if (addNewPage) {
          doc.addPage();
          startY = 10;
        }

        ////// Print Order Info //////////////
        const orderInfo = orderInfoData(order, bundleOrder);

        const fields = [...orderFields, ...flowInfoFields, "partName", "bundleOrderNo"];
        let columns = orderInfo.columns
          .filter(c => fields.includes(c.dataKey))
          .map(c => ({
            ...c,
            header: orderFields.includes(c.dataKey)
              ? lodashGet(i18nMessages, `resources.orders.fields.${c.dataKey}`, c.header)
              : lodashGet(i18nMessages, `resources.orders.fields.flowInfo.${c.dataKey}`, c.header)
          }));

        var cutOrderAutoTableOptions = {
          startY: startY + 10,
          body: orderInfo.body,
          columns
        };

        doc.text("Order Details", 7, startY + 7);
        addTable(doc, cutOrderAutoTableOptions, { tableWidth });
        startY = doc.autoTable.previous.finalY;

        //** Print Bundle Order Info */
        var bundleOrderAutoTableOptions = {
          startY: startY + 10,
          body: rowsBundleOrder,
          columns: columnsBundleOrder,
          headStyles: { fillColor: [100, 175, 200], lineColor: 100 }
        };
        doc.text(`Bundling Details`, 7, startY + 7);
        addTable(doc, bundleOrderAutoTableOptions, { tableWidth });
        startY = doc.autoTable.previous.finalY;

        //** Print Bundle Sheet *//
        let columnsLay = [
          { dataKey: "style", header: "Style" },
          { dataKey: "color", header: "Color" },
          { dataKey: "bundleNo", header: "Bundle No" },
          { dataKey: "sizeGroup", header: "Inseam" },
          { dataKey: "size", header: "Size" },
          { dataKey: "ratio", header: "Ratio" },
          { dataKey: "shade", header: "Shade" },
          { dataKey: "serial", header: "Serial" },
          { dataKey: "qty", header: "Pcs" },
          { dataKey: "rolls", header: "Rolls" }
        ];

        if (type !== "compact") {
          columnsLay = [...columnsLay, { dataKey: "supplierRolls", header: "Supplier Rolls" }];
        }

        layList
          .filter(e => isTrue(e.bundleGenerated))
          .sort((a, b) => a.bundleGeneratedAt - b.bundleGeneratedAt)
          .forEach(lay => {
            const layBundleList = currBundleList
              .filter(b => b.layId === lay.id)
              .map(b => ({
                ...b,
                serial: `${finalSerialNo(b.start, resetDigits)}-${finalSerialNo(b.end, resetDigits)}`,
                rolls: b.rollSerials?.map(e => e.rollNo).join(", "),
                supplierRolls: b.rollSerials?.map(e => e.supplierRollNo).join(", ")
              }));
            if (!isEmpty(layBundleList)) {
              if (pageHeight - (startY + 15) < minReqHeight) {
                doc.addPage();
                startY = 10;
              }

              const cutOrder = cutOrderList?.find(co => co.id === lay.orderFlowId) || {};
              const sizeGroups = getDistinctValues(layBundleList?.map(b => b.sizeGroup)?.filter(e => e !== "G1"));
              if (isEmpty(sizeGroups)) {
                columnsLay = columnsLay.filter(c => c.dataKey !== "sizeGroup");
              }
              if (cutOrder?.styleList?.length === 1) {
                columnsLay = columnsLay.filter(c => c.dataKey !== "style");
              }
              if (cutOrder?.colorList?.length === 1) {
                columnsLay = columnsLay.filter(c => c.dataKey !== "color");
              }
              columnsLay = columnsLay.filter(c => bundleExportFields.includes(c.dataKey));

              const body =
                layBundleList.length > 1
                  ? [...layBundleList, { shade: "Total", qty: layBundleList.reduce((acc, b) => acc + b.qty, 0) }]
                  : [...layBundleList];

              let title = `LAY ${lay.layNo}, O. LAY ${lay.extLayNo}, CUT ${body[0]?.cutNo}, ${cutOrder?.lotValue}, Shrinkage: ${
                layBundleList[0]?.shrinkage || ""
              } PATTERN NO : ${body[0]?.patternNo || ""}`;
              doc.text(title, 7, startY + 7);
              startY = startY + 3;
              if (type === BundleSheetType.NORMAL) {
                doc.autoTable(columnsLay, body, {
                  styles: { halign: "center" },
                  startY: startY + 7,
                  margin: { left: 7, right: 7 }
                });
                startY = doc.autoTable.previous.finalY;
              } else {
                startY = print2TableColumnWise(doc, startY, columnsLay, body, tableWidth - 7);
              }
            }
          });
        addNewPage = true;
      }
    });

  doc.putTotalPages(totalPagesExp);
  doc.save(filename);
};

// sortType = 'Bundle' | 'Serial'
export const getSortedBundleList = (bundleList, sortType, { cutOrderList, bundleOrderList, layList, order } = {}) => {
  if (isEmpty(bundleList)) return [];

  const orderConfig = isEmpty(cutOrderList) ? {} : cutOrderList[0]?.orderConfig;

  const bundleResetList = listFromCsv(orderConfig?.bundleResetAt);
  const serialResetList = listFromCsv(orderConfig?.serialResetAt);

  const bundleOrder = isEmpty(bundleOrderList) ? {} : bundleOrderList[0];
  const sizeBreakupList = bundleOrder?.boSizeBreakupList || [];
  const sizeSerialMap = sizeBreakupList.reduce((acc, sb) => ({ ...acc, [sb.sizeKey]: sb.serialNo || 0 }), {});
  const sizeGroupSerialMap = sizeBreakupList.reduce((acc, sb) => ({ ...acc, [sb.sizeGroup]: sb.serialNo || 0 }), {});

  const sortedBundleList = bundleList
    .map(bundle => {
      const cutOrder = cutOrderList?.find(e => e.id === bundle.cutOrderId) || {};
      const bundleOrder = bundleOrderList?.find(e => e.id === bundle.bundleOrderId) || {};
      const lay = layList?.find(e => e.id === bundle.layId) || {};
      const rollSerials = JSON.parse(bundle.rollSerials);
      const layFields = ["layNo", "extLayNo", "cutNo", "prodType"];
      const cutOrderFields = ["fpo", "unitId", "part", "lotType", "lot", "lotValue"];
      const bundleOrderFields = ["bundleOrderNo", "flowRefs", "customerFlowRefs", "destinations", "deliveries", "delModes"];
      return {
        ...bundle,
        ...layFields.reduce((acc, field) => ({ ...acc, [field]: lay[field] }), {}),
        ...cutOrderFields.reduce((acc, field) => ({ ...acc, [field]: cutOrder[field] }), {}),
        ...bundleOrderFields.reduce((acc, field) => ({ ...acc, [field]: bundleOrder[field] }), {}),
        cutOrder,
        bundleOrder,
        lay,
        customer: order?.customer?.name,
        poRef: order?.poRef,
        product: cutOrder?.product?.name,
        rolls: rollSerials?.map(e => e.rollNo).join(", "),
        supplierRolls: rollSerials?.map(e => e.supplierRollNo).join(", ")
      };
    })
    .map(bundle => {
      const sortFields = [bundle.cutOrder?.plannedAt || 0];
      if (sortType === "Bundle") {
        //[BundleOrder, Lot, Style, Color, Lay, Size, Size Group]
        if (bundleResetList.includes("Style")) {
          sortFields.push(bundle.style);
        }
        if (bundleResetList.includes("Color")) {
          sortFields.push(bundle.color);
        }
        if (bundleResetList.includes("BundleOrder")) {
          sortFields.push(bundle?.bundleOrder?.serialNo || 0);
        }
        if (bundleResetList.includes("Lay")) {
          sortFields.push(`${bundle.lay?.layNo || 0}`.padStart(4, "0"));
        }
        if (bundleResetList.includes("SizeGroup")) {
          sortFields.push(`${sizeGroupSerialMap[bundle.sizeGroup] || 0}`.padStart(3, "0"));
        }
        if (bundleResetList.includes("Size")) {
          sortFields.push(`${sizeSerialMap[bundle.sizeKey] || 0}`.padStart(3, "0"));
        }
        sortFields.push(`${bundle.bundleNo}`.padStart(6, "0"));
      } else {
        //[Lot, Style, Color, Lay, Size, Lay-Size-Ratio, Size Group, Bundle]
        if (serialResetList.includes("Style")) {
          sortFields.push(bundle.style);
        }
        if (serialResetList.includes("Color")) {
          sortFields.push(bundle.color);
        }
        if (serialResetList.includes("Lay")) {
          const layNo = `${bundle.lay?.layNo || 0}`;
          sortFields.push(layNo.padStart(4, "0"));
        }
        if (serialResetList.includes("SizeGroup")) {
          sortFields.push(`${sizeGroupSerialMap[bundle.sizeGroup] || 0}`.padStart(3, "0"));
        }
        if (serialResetList.includes("Size")) {
          sortFields.push(`${sizeSerialMap[bundle.sizeKey] || 0}`.padStart(3, "0"));
        }
        if (serialResetList.includes("Ratio")) {
          sortFields.push(`${bundle.ratio || 0}`.padStart(2, "0"));
        }
        if (serialResetList.includes("Bundle")) {
          sortFields.push(`${bundle.bundleNo}`.padStart(6, "0"));
        }
        sortFields.push(`${bundle.start}`.padStart(8, "0"));
      }

      const sortField = sortFields.join("-");
      return { ...bundle, sortField };
    })
    .sort((a, b) => (a.sortField < b.sortField ? -1 : 1));

  return sortedBundleList;
};

export const printBundleTag = ({ order, cutOrderList, bundleOrderList, layList, bundleList, bundleTagSetting, resetDigits }) => {
  if (isEmpty(cutOrderList) || isEmpty(bundleOrderList) || isEmpty(layList)) return;

  const orderConfig = cutOrderList?.find(e => !isEmpty(e?.orderConfig?.bundleParts))?.orderConfig;

  let bundlePartList = !isEmpty(orderConfig?.bundleParts) ? JSON.parse(orderConfig?.bundleParts) : [];
  bundlePartList = bundlePartList
    .map(e => ({ ...e, productName: order?.flowInfoList?.find(fi => fi.product?.id === Number(e.productId))?.product?.name || "" }))
    .flatMap(e => listFromCsv(e.parts).map(part => ({ ...e, part })));

  const finalBundleList = isEmpty(bundlePartList)
    ? bundleList
    : bundlePartList.flatMap(p => bundleList.map(bundle => ({ ...bundle, bundlePart: p.part, productName: p.productName })));

  var doc;
  const { options = { orientation: "p", unit: "mm", format: [210, 297] }, columns, rows, fields = [], ticket = {} } = bundleTagSetting || {};

  const {
    defaultTitleStyle = defTitleStyle,
    defaultValueStyle = defValueStyle,
    defaultCharLength = 20,
    defaultValueType = "text",
    padding,
    margin
  } = ticket;

  doc = new jsPDF(options);

  const cellCount = columns * rows;
  const width = options.format[0]; // Page Width
  const height = options.format[1]; // Page Height
  const cellWidth = width / columns;
  const cellHeight = height / rows;

  let posX, posY;
  // let nextPart;
  let docCellNumber = 0; // Cell Number across entire doc (not on one page)
  for (let i = 0; i < finalBundleList.length; i++) {
    docCellNumber++;
    const bundle = finalBundleList[i];
    let pageCellNumber = docCellNumber % cellCount; // Cell number on current page

    ///// Draw Vertical and horizontal line on each new page /////
    if (pageCellNumber === 1 && cellCount > 1) {
      if (docCellNumber > 1) {
        doc.addPage();
      }
      doc.setDrawColor(150);
      // Draw Vertical Line //
      for (let i = 1; i < columns; i++) {
        const xFrom = (width * i) / columns;
        dottedLine(doc, xFrom, 0, xFrom, height, 2);
      }
      // Draw Horizontal Line //
      for (let i = 1; i < rows; i++) {
        const yFrom = (height * i) / rows;
        dottedLine(doc, 0, yFrom, width, yFrom, 2);
      }
    }

    let rowNo = (docCellNumber - 1) % cellCount;
    rowNo = Math.floor(rowNo / columns);

    posY = (height / rows) * rowNo;
    posX = (width / columns) * ((docCellNumber - 1) % columns);

    // // On Part Change, Print bundles in Fresh Row //
    // nextPart = i + 1 < finalBundleList.length ? finalBundleList[i + 1].bundlePart : null;
    // if (nextPart && `${nextPart}` !== `${bundle.bundlePart}` && docCellNumber % columns !== 0) {
    //   docCellNumber += columns - (docCellNumber % columns);
    // }

    drawBundle(doc, fields, { ...bundle, size: `${bundle?.size}${bundle?.sizeGroup !== "G1" ? `(${bundle.sizeGroup})` : ""}` }, posX, posY, {
      width: cellWidth,
      height: cellHeight,
      padding,
      margin,
      defaultTitleStyle,
      defaultValueStyle,
      defaultCharLength,
      defaultValueType,
      resetDigits
    });

    // Add new page
    if (cellCount === 1) {
      doc.addPage();
    }
  }

  doc.save(`BUNDLE_TAGS.pdf`);
};

export const printPieceTag = (bundleList, pieceTagSetting, resetDigits) => {
  if (isEmpty(bundleList) || isEmpty(pieceTagSetting)) return;

  const {
    copies = 1,
    ticket,
    fields = [],
    options = { orientation: "l", unit: "mm", format: [101, 76.2], compressPdf: true }
  } = pieceTagSetting || {};

  const {
    defaultTitleStyle = defTitleStyle,
    defaultValueStyle = defValueStyle,
    defaultCharLength = 100,
    defaultValueType = "text",
    defaultValueOnly = true,
    padding,
    margin
  } = ticket;
  const width = options.format[0];
  const height = options.format[1];

  let filename = `PIECE_TAGS`;
  var doc = new jsPDF(options);

  let pieceInfoList = [];

  for (let i = 0; i < bundleList?.length; i++) {
    const bundle = bundleList[i];
    const rollSerialList = !isEmpty(bundle.rollSerials) ? JSON.parse(bundle.rollSerials) : [];

    const serialStart = bundle.start || 0;
    const serialEnd = bundle.end || bundle.qty;
    for (let j = serialStart; j <= serialEnd; j++) {
      const serialNo = `${j}`.padStart(4, "0");
      const rollSerial = rollSerialList.find(e => j >= Number(e.start) && j <= Number(e.end));
      pieceInfoList.push({
        ...bundle,
        serialNo: finalSerialNo(serialNo, resetDigits),
        code: `${bundle.code},${serialNo}`,
        rollNo: rollSerial?.rollNo || "",
        supplierRollNo: rollSerial?.supplierRollNo || "",
        shade: rollSerial?.shade || bundle?.shade || ""
      });
    }
    pieceInfoList
      .sort((a, b) => a.serialNo - b.serialNo)
      .flatMap(ct =>
        Array(copies)
          .fill(0)
          .map(() => ct)
      );
  }

  for (let i = 0; i < pieceInfoList.length; i++) {
    const pieceInfo = pieceInfoList[i];
    drawPieceTag(doc, fields, pieceInfo, 0, 0, {
      width,
      height,
      padding,
      margin,
      defaultTitleStyle,
      defaultValueStyle,
      defaultCharLength,
      defaultValueType,
      defaultValueOnly
    });

    if (i < pieceInfoList.length - 1) {
      doc.addPage();
    }
  }

  doc.save(filename.replaceAll(".", "_"));
};

export const printSerialPlan = ({
  order,
  cutOrderList,
  bundleOrderList,
  layList,
  bundleList,
  tenant,
  flowInfoFields = [],
  orderFields = [],
  i18nMessages,
  resetDigits,
  unit = {}
}) => {
  if (
    isEmpty(order) ||
    isEmpty(bundleOrderList) ||
    isEmpty(layList) ||
    isEmpty(bundleList) ||
    isEmpty(orderFields) ||
    isEmpty(flowInfoFields) ||
    isEmpty(i18nMessages)
  ) {
    return;
  }

  var doc = new jsPDF();

  const filename = `SERIAL_PLAN.pdf`;

  setDefault(doc, "SERIAL PLAN", tenant, null, unit);
  doc.setFontSize(10);
  const pageHeight = doc.internal.pageSize.getHeight();
  let startY = 24;

  const tableWidth = doc.internal.pageSize.getWidth() - 14;

  let addNewPage = false;
  bundleOrderList
    .sort((a, b) => a.serialNo - b.serialNo)
    .forEach(bundleOrder => {
      const currBundleList = bundleList.filter(b => b.bundleOrderId === bundleOrder.id);
      if (!isEmpty(currBundleList)) {
        const boSizeBreakupList = bundleOrder.boSizeBreakupList?.sort((a, b) => a.serialNo - b.serialNo) || [];
        const sizeKeyList = boSizeBreakupList.map(sb => sb.sizeKey);

        const columnsBundleOrder = [
          { dataKey: "info", header: "Info" },
          ...boSizeBreakupList.map(sb => ({ dataKey: sb.sizeKey, header: sb.size })), // TODO: Handle Size Group
          { dataKey: "total", header: "Total" }
        ];

        const bundlingQty = getDistinctObjectValues(boSizeBreakupList)?.reduce((acc, sb) => acc + sb.qty, 0);
        const bundlingQtyMap = getDistinctObjectValues(boSizeBreakupList)?.reduce(
          (acc, sb) => ({ ...acc, [sb.sizeKey]: (acc[sb.sizeKey] || 0) + sb.qty }),
          {}
        );

        const bundleQtyMap = sizeKeyList.reduce((acc, sizeKey) => {
          const qty = currBundleList.filter(b => b.sizeKey === sizeKey).reduce((acc, b) => acc + b.qty, 0);
          return { ...acc, [sizeKey]: qty };
        }, {});
        const bundleQty = Object.values(bundleQtyMap).reduce((acc, qty) => acc + qty, 0);

        const balanceQtyMap = sizeKeyList.reduce((acc, sizeKey) => {
          return { ...acc, [sizeKey]: (bundlingQtyMap[sizeKey] || 0) - (bundleQtyMap[sizeKey] || 0) };
        }, {});
        const balanceQty = Object.values(balanceQtyMap).reduce((acc, qty) => acc + qty, 0);

        const rowsBundleOrder = [
          { info: "Bundle Required Qty", total: bundlingQty, ...bundlingQtyMap },
          { info: "Bundle Completed Qty", total: bundleQty, ...bundleQtyMap },
          { info: "Balance Qty", total: balanceQty, ...balanceQtyMap }
        ];

        //** Print Order Info for second Bundle Order ownwards in new Page */
        if (addNewPage) {
          doc.addPage();
          startY = 10;
        }

        ////// Print Order Info //////////////
        const orderInfo = orderInfoData(order, bundleOrder);

        const fields = [...orderFields, ...flowInfoFields, "partName", "bundleOrderNo"];
        let columns = orderInfo.columns
          .filter(c => fields.includes(c.dataKey))
          .map(c => ({
            ...c,
            header: orderFields.includes(c.dataKey)
              ? lodashGet(i18nMessages, `resources.orders.fields.${c.dataKey}`, c.header)
              : lodashGet(i18nMessages, `resources.orders.fields.flowInfo.${c.dataKey}`, c.header)
          }));

        const cutOrderAutoTableOptions = {
          startY: startY + 10,
          body: orderInfo.body,
          columns
        };

        doc.text("Order Details", 7, startY + 7);
        addTable(doc, cutOrderAutoTableOptions, { tableWidth });
        startY = doc.autoTable.previous.finalY;

        //** Print Bundle Order Info */
        const bundleOrderAutoTableOptions = {
          startY: startY + 10,
          body: rowsBundleOrder,
          columns: columnsBundleOrder,
          headStyles: { fillColor: [100, 175, 200], lineColor: 100 }
        };
        doc.text(`Bundling Details`, 7, startY + 7);
        addTable(doc, bundleOrderAutoTableOptions, { tableWidth });
        startY = doc.autoTable.previous.finalY;

        //** Print Serial Plan *//
        let columnsLay = [
          { dataKey: "style", header: "Style" },
          { dataKey: "color", header: "Color" },
          { dataKey: "sizeGroup", header: "Size Group" },
          { dataKey: "size", header: "Size" },
          { dataKey: "ratio", header: "Ratio" },
          { dataKey: "bundleNo", header: "BundleNo" },
          { dataKey: "from", header: "From" },
          { dataKey: "to", header: "To" }
        ];

        layList
          .filter(e => isTrue(e.bundleGenerated))
          .sort((a, b) => a.bundleGeneratedAt - b.bundleGeneratedAt)
          .forEach(lay => {
            const layBundleList = currBundleList.filter(b => b.layId === lay.id);
            if (!isEmpty(layBundleList)) {
              if (pageHeight - (startY + 15) < minReqHeight) {
                doc.addPage();
                startY = 10;
              }

              const cutOrder = cutOrderList?.find(co => co.id === lay.orderFlowId) || {};
              const serialResetList = listFromCsv(cutOrder?.orderConfig?.serialResetAt);

              const sizeGroups = getDistinctValues(layBundleList?.map(b => b.sizeGroup)?.filter(e => e !== "G1"));
              if (isEmpty(sizeGroups)) {
                columnsLay = columnsLay.filter(c => c.dataKey !== "sizeGroup");
              }
              if (cutOrder?.styleList?.length === 1) {
                columnsLay = columnsLay.filter(c => c.dataKey !== "style");
              }
              if (cutOrder?.colorList?.length === 1) {
                columnsLay = columnsLay.filter(c => c.dataKey !== "color");
              }
              if (isEmpty(serialResetList) || !serialResetList.includes("Bundle")) {
                columnsLay = columnsLay.filter(c => c.dataKey !== "bundleNo");
              }

              const idFields = columnsLay.map(c => c.dataKey).filter(dataKey => !["from", "to"].includes(dataKey));
              const bundles = layBundleList.map(bundle => ({ ...bundle, rowId: idFields.map(field => bundle[field]).join("_") }));
              const rowIds = getDistinctValues(bundles.map(bundle => bundle.rowId));

              const body = rowIds.map(rowId => {
                const rowBundles = bundles.filter(b => b.rowId === rowId);
                const start = rowBundles[0]?.start || 0;
                const end = rowBundles[rowBundles.length - 1]?.end || 0;
                return { ...rowBundles[0], from: finalSerialNo(start, resetDigits), to: finalSerialNo(end, resetDigits) };
              });

              let title = `LAY ${lay.layNo}, ${cutOrder?.lotValue}, Shrinkage: ${layBundleList[0]?.shrinkage || ""}`;
              doc.text(title, 7, startY + 7);
              startY = startY + 3;
              startY = print2TableColumnWise(doc, startY, columnsLay, body, tableWidth - 7);
            }
          });
        addNewPage = true;
      }
    });

  doc.putTotalPages(totalPagesExp);
  doc.save(filename);
};

export const printPanelReplacementPlan = ({
  order,
  cutOrderList,
  bundleOrderList,
  layList,
  bundleList,
  tenant,
  flowInfoFields = [],
  orderFields = [],
  i18nMessages,
  resetDigits,
  unit = {}
}) => {
  if (
    isEmpty(order) ||
    isEmpty(bundleOrderList) ||
    isEmpty(layList) ||
    isEmpty(bundleList) ||
    isEmpty(orderFields) ||
    isEmpty(flowInfoFields) ||
    isEmpty(i18nMessages)
  ) {
    return;
  }

  var doc = new jsPDF();

  const filename = `PANEL_REPLACEMENT_PLAN.pdf`;

  setDefault(doc, "PANEL REPLACEMENT PLAN", tenant, null, unit);
  doc.setFontSize(10);
  const pageHeight = doc.internal.pageSize.getHeight();
  let startY = 24;

  const tableWidth = doc.internal.pageSize.getWidth() - 14;

  let addNewPage = false;
  bundleOrderList
    .sort((a, b) => a.serialNo - b.serialNo)
    .forEach(bundleOrder => {
      const currBundleList = bundleList.filter(b => b.bundleOrderId === bundleOrder.id);
      if (!isEmpty(currBundleList)) {
        const boSizeBreakupList = bundleOrder.boSizeBreakupList?.sort((a, b) => a.serialNo - b.serialNo) || [];
        const sizeKeyList = boSizeBreakupList.map(sb => sb.sizeKey);

        const columnsBundleOrder = [
          { dataKey: "info", header: "Info" },
          ...boSizeBreakupList.map(sb => ({ dataKey: sb.sizeKey, header: sb.size })), // TODO: Handle Size Group
          { dataKey: "total", header: "Total" }
        ];

        const bundlingQty = getDistinctObjectValues(boSizeBreakupList)?.reduce((acc, sb) => acc + sb.qty, 0);
        const bundlingQtyMap = getDistinctObjectValues(boSizeBreakupList)?.reduce(
          (acc, sb) => ({ ...acc, [sb.sizeKey]: (acc[sb.sizeKey] || 0) + sb.qty }),
          {}
        );

        const bundleQtyMap = sizeKeyList.reduce((acc, sizeKey) => {
          const qty = currBundleList.filter(b => b.sizeKey === sizeKey).reduce((acc, b) => acc + b.qty, 0);
          return { ...acc, [sizeKey]: qty };
        }, {});
        const bundleQty = Object.values(bundleQtyMap).reduce((acc, qty) => acc + qty, 0);

        const balanceQtyMap = sizeKeyList.reduce((acc, sizeKey) => {
          return { ...acc, [sizeKey]: (bundlingQtyMap[sizeKey] || 0) - (bundleQtyMap[sizeKey] || 0) };
        }, {});
        const balanceQty = Object.values(balanceQtyMap).reduce((acc, qty) => acc + qty, 0);

        const rowsBundleOrder = [
          { info: "Bundle Required Qty", total: bundlingQty, ...bundlingQtyMap },
          { info: "Bundle Completed Qty", total: bundleQty, ...bundleQtyMap },
          { info: "Balance Qty", total: balanceQty, ...balanceQtyMap }
        ];

        //** Print Order Info for second Bundle Order ownwards in new Page */
        if (addNewPage) {
          doc.addPage();
          startY = 10;
        }

        ////// Print Order Info //////////////
        const orderInfo = orderInfoData(order, bundleOrder);

        const fields = [...orderFields, ...flowInfoFields, "partName", "bundleOrderNo"];
        let columns = orderInfo.columns
          .filter(c => fields.includes(c.dataKey))
          .map(c => ({
            ...c,
            header: orderFields.includes(c.dataKey)
              ? lodashGet(i18nMessages, `resources.orders.fields.${c.dataKey}`, c.header)
              : lodashGet(i18nMessages, `resources.orders.fields.flowInfo.${c.dataKey}`, c.header)
          }));

        var cutOrderAutoTableOptions = {
          startY: startY + 10,
          body: orderInfo.body,
          columns
        };

        doc.text("Order Details", 7, startY + 7);
        addTable(doc, cutOrderAutoTableOptions, { tableWidth });
        startY = doc.autoTable.previous.finalY;

        //** Print Bundle Order Info */
        var bundleOrderAutoTableOptions = {
          startY: startY + 10,
          body: rowsBundleOrder,
          columns: columnsBundleOrder,
          headStyles: { fillColor: [100, 175, 200], lineColor: 100 }
        };
        doc.text(`Bundling Details`, 7, startY + 7);
        addTable(doc, bundleOrderAutoTableOptions, { tableWidth });
        startY = doc.autoTable.previous.finalY;

        //** Print Panel Replacement Plan **//
        let columnsLay = [
          { dataKey: "style", header: "Style" },
          { dataKey: "color", header: "Color" },
          { dataKey: "shade", header: "Shade" },
          { dataKey: "sizeGroup", header: "Size Group" },
          { dataKey: "size", header: "Size" },
          { dataKey: "ratio", header: "Ratio" },
          { dataKey: "bundleNo", header: "BundleNo" },
          { dataKey: "start", header: "From" },
          { dataKey: "end", header: "To" },
          { dataKey: "rollNo", header: "Roll No" },
          { dataKey: "supplierRollNo", header: "Supplier Roll No" }
        ];

        layList
          .filter(e => isTrue(e.bundleGenerated))
          .sort((a, b) => a.bundleGeneratedAt - b.bundleGeneratedAt)
          .forEach(lay => {
            const layBundleList = currBundleList.filter(b => b.layId === lay.id);
            if (!isEmpty(layBundleList)) {
              if (pageHeight - (startY + 15) < minReqHeight) {
                doc.addPage();
                startY = 10;
              }

              const cutOrder = cutOrderList?.find(co => co.id === lay.orderFlowId) || {};
              const serialResetList = listFromCsv(cutOrder?.orderConfig?.serialResetAt);
              const sizeGroups = getDistinctValues(layBundleList?.map(b => b.sizeGroup)?.filter(e => e !== "G1"));
              if (isEmpty(sizeGroups)) {
                columnsLay = columnsLay.filter(c => c.dataKey !== "sizeGroup");
              }
              if (cutOrder?.styleList?.length === 1) {
                columnsLay = columnsLay.filter(c => c.dataKey !== "style");
              }
              if (cutOrder?.colorList?.length === 1) {
                columnsLay = columnsLay.filter(c => c.dataKey !== "color");
              }
              if (isEmpty(serialResetList) || !serialResetList.includes("Bundle")) {
                columnsLay = columnsLay.filter(c => c.dataKey !== "bundleNo");
              }

              const idFields = columnsLay.map(c => c.dataKey).filter(dataKey => !["start", "end", "rollNo"].includes(dataKey));
              const bundles = layBundleList.map(bundle => ({
                ...bundle,
                rollList: JSON.parse(bundle.rollSerials),
                rowId: idFields.map(field => bundle[field]).join("_")
              }));
              const rowIds = getDistinctValues(bundles.map(bundle => bundle.rowId));

              const body = rowIds.flatMap(rowId => {
                const rowBundles = bundles.filter(b => b.rowId === rowId);
                const rollList = rowBundles.flatMap(bundle => bundle.rollList || []);
                const mergedRollList = mergeRollList(rollList);

                return mergedRollList
                  .sort((a, b) => a.start - b.start)
                  .map(roll => ({ ...rowBundles[0], ...roll }))
                  .map(e => ({ ...e, start: finalSerialNo(e.start, resetDigits), end: finalSerialNo(e.end, resetDigits) }));
              });

              let title = `LAY ${lay.layNo}, ${cutOrder?.lotValue}, Shrinkage: ${layBundleList[0]?.shrinkage || ""}`;
              doc.text(title, 7, startY + 7);
              startY = startY + 3;
              startY = print2TableColumnWise(doc, startY, columnsLay, body, tableWidth - 7);
            }
          });
        addNewPage = true;
      }
    });

  doc.putTotalPages(totalPagesExp);
  doc.save(filename);
};

const drawPieceTag = (
  doc,
  fields,
  pieceInfo,
  pointX,
  pointY,
  { width, height, margin, defaultTitleStyle, defaultValueStyle, defaultCharLength, defaultValueType, defaultValueOnly }
) => {
  doc.setDrawColor(0);
  //   const { left: ml = 2, right: mr = 2, top: mt = 2, bottom: mb = 2 } = margin || {};
  const { right: mr = 2, bottom: mb = 2 } = margin || {};
  //   doc.rect(pointX + ml, pointY + mt, width - ml - mr, height - mt - mb);

  //* Find Length of longest label per column **/
  const startXList = getDistinctValues(fields.filter(f => !isEmpty(f.coordinates)).map(field => field.coordinates[0] || 0));
  const labelLengthMap = startXList.reduce(
    (acc, startX) => ({
      ...acc,
      [startX]:
        fields
          .filter(f => isEmpty(f.valueType) || f.valueType === "text")
          .filter(f => isEmpty(f.valueOnly) || isFalse(f.valueOnly))
          .filter(f => !isEmpty(f.coordinates) && f.coordinates[0] === startX)
          .map(f => f.title || "")
          .sort((a, b) => b.length - a.length)[0]?.length || 0
    }),
    {}
  );

  for (let i = 0; i < fields.length; i++) {
    const field = fields[i];
    const [startX, startY, endX, endY] = field.coordinates || [];
    const valueType = field.valueType || defaultValueType;
    const valueOnly = isEmpty(field.valueOnly) ? defaultValueOnly : field.valueOnly;

    // Write Label
    const titleStyle = { ...defaultTitleStyle, ...field.titleStyle };
    if (valueType !== "Barcode" && valueType !== "QR" && !valueOnly) {
      doc.setFontSize(titleStyle.fontSize);
      doc.setFont(titleStyle.fontFamily, titleStyle.fontWeight);
      doc.text(field.title || "", pointX + startX, pointY + startY);
    }

    const labelLength = valueOnly ? 0 : labelLengthMap[startX];
    const labelWidth = labelLength * (titleStyle.fontSize / 4.5);

    // Write Value
    if (valueType === "text") {
      const valueStyle = { ...defaultValueStyle, ...field.valueStyle };
      const charLength = field.charLength || defaultCharLength;

      let value = getStrictText(pieceInfo[field.dataKey], charLength);
      if (!isEmpty(field.dataKeys)) {
        const dataKeys = listFromCsv(field.dataKeys);
        const joinChar = field.joinChar || ",";
        value = dataKeys
          .map(dataKey => pieceInfo[dataKey])
          .filter(e => !isEmpty(e))
          .join(joinChar);
        value = getStrictText(value, charLength);
      }

      doc.setFontSize(valueStyle.fontSize);
      doc.setFont(valueStyle.fontFamily, valueStyle.fontWeight);
      doc.text(value, pointX + startX + labelWidth, pointY + startY, valueStyle.align || "left");
    }

    //** Print Barcode **//
    if (valueType === "Barcode") {
      const boxWidth = (endX || width - mr) - startX;
      const boxHeight = (endY || height - mb) - startY;
      //   const barCodeWidth = Math.min(boxWidth, boxHeight, field.width || 10);
      //   const barCodeHeight = Math.min(boxWidth, boxHeight, field.height || 10);

      const value = pieceInfo[field.dataKey];

      const canvas = document.createElement("canvas");
      JsBarcode(canvas, value, barcodeOptions);

      const imgData = canvas.toDataURL("image/png");

      doc.addImage(imgData, "PNG", pointX + startX, pointY + startY, boxWidth, boxHeight, "", "FAST");
    }

    //** Print QR **//
    if (valueType === "QR") {
      const boxWidth = (endX || width - mr) - startX;
      const boxHeight = (endY || height - mb) - startY;
      let qrSize = Math.min(boxWidth, boxHeight);
      if (!isEmpty(field.size)) {
        qrSize = Math.min(qrSize, field.size);
      }

      const value = pieceInfo[field.dataKey];

      let svg = ReactDOMServer.renderToStaticMarkup(<QRCode value={`${value}`} level="H" />);
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      const v = canvg.fromString(context, svg);
      v.render();
      const imgData = canvas.toDataURL("image/png");

      doc.addImage(imgData, "PNG", pointX + startX + (boxWidth - qrSize) / 2, pointY + startY + (boxHeight - qrSize) / 2, qrSize, qrSize, "", "FAST");
    }
  }
};

const drawBundle = (
  doc,
  fields,
  bundle,
  pointX,
  pointY,
  { width, height, margin, defaultTitleStyle, defaultValueStyle, defaultCharLength, defaultValueType, resetDigits }
) => {
  doc.setDrawColor(0);
  const { left: ml = 2, right: mr = 2, top: mt = 2, bottom: mb = 2 } = margin || {};
  doc.rect(pointX + ml, pointY + mt, width - ml - mr, height - mt - mb);

  //* Find Length of longest label per column **/
  const startXList = getDistinctValues(fields.filter(f => !isEmpty(f.coordinates)).map(field => field.coordinates[0] || 0));
  const labelLengthMap = startXList.reduce(
    (acc, startX) => ({
      ...acc,
      [startX]:
        fields
          .filter(f => isEmpty(f.valueType) || f.valueType === "text")
          .filter(f => !isEmpty(f.coordinates) && f.coordinates[0] === startX)
          .map(f => f.title || "")
          .sort((a, b) => b.length - a.length)[0]?.length || 7
    }),
    {}
  );

  for (let i = 0; i < fields.length; i++) {
    const field = fields[i];
    const [startX, startY, endX, endY] = field.coordinates || [];
    const valueType = field.valueType || defaultValueType;

    // Write Label
    const titleStyle = { ...defaultTitleStyle, ...field.titleStyle };
    if (valueType !== "QR") {
      doc.setFontSize(titleStyle.fontSize);
      doc.setFont(titleStyle.fontFamily, titleStyle.fontWeight);
      doc.text(field.title || "", pointX + startX, pointY + startY);
    }
    const labelLength = labelLengthMap[startX] || 7;
    // const labelWidth = (field.title?.length || 7) * (titleStyle.fontSize / 4.5);
    const labelWidth = labelLength * (titleStyle.fontSize / 4.5);

    // Write Value
    if (valueType === "text") {
      const valueStyle = { ...defaultValueStyle, ...field.valueStyle };
      const charLength = field.charLength || defaultCharLength;
      doc.setFontSize(valueStyle.fontSize);
      doc.setFont(valueStyle.fontFamily, valueStyle.fontWeight);
      const value =
        field.title === "S:" ? getText(bundle[field.dataKey], charLength) + `(${bundle?.ratio})` : getText(bundle[field.dataKey], charLength);
      doc.text(value, pointX + startX + labelWidth, pointY + startY);
    }

    if (valueType === "serial") {
      const labelWidth = titleStyle.fontSize * 1.5;
      // const boxWidth = (cellWidth - labelWidth - 2) / 2;

      const boxWidth = ((endX || width - mr) - startX - labelWidth) / 2 - 1;
      const lineHeight = endY - startY;

      // Draw boxes
      doc.rect(pointX + startX + labelWidth, pointY + startY - lineHeight / 2 - 0.5, boxWidth, lineHeight);
      doc.rect(pointX + startX + labelWidth + boxWidth + 1, pointY + startY - lineHeight / 2 - 0.5, boxWidth, lineHeight);

      // Write Serial
      doc.text(`${finalSerialNo(bundle.start, resetDigits)}`, pointX + startX + labelWidth + boxWidth / 2, pointY + startY, "center");
      doc.text(`${finalSerialNo(bundle.end, resetDigits)}`, pointX + startX + labelWidth + boxWidth + 1 + boxWidth / 2, pointY + startY, "center");
    }

    //** Print QR **//
    if (valueType === "QR") {
      const boxWidth = (endX || width - mr) - startX;
      const boxHeight = (endY || height - mb) - startY;
      const qrSize = Math.min(boxWidth, boxHeight, field.size || 10);

      let svg = ReactDOMServer.renderToStaticMarkup(<QRCode value={`${bundle.code || bundle.id}`} level="H" />);
      var canvas = document.createElement("canvas");
      var context = canvas.getContext("2d");
      const v = canvg.fromString(context, svg);
      v.render();
      var imgData = canvas.toDataURL("image/png");

      doc.addImage(imgData, "PNG", pointX + startX + (boxWidth - qrSize) / 2, pointY + startY + (boxHeight - qrSize) / 2, qrSize, qrSize, "", "FAST");
    }
  }
};

const getStrictText = (value, charLength = 20) => {
  if (isEmpty(value)) return "";
  value = `${value}`;
  const valueLength = value.length;
  const lines = Math.ceil(valueLength / charLength);
  return Array(lines)
    .fill("")
    .map((_, idx) => value.substring(idx * charLength, (idx + 1) * charLength));
};

const dottedLine = (doc, xFrom, yFrom, xTo, yTo, segmentLength) => {
  // Calculate line length (c)
  var a = Math.abs(xTo - xFrom);
  var b = Math.abs(yTo - yFrom);
  var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));

  // Make sure we have an odd number of line segments (drawn or blank)
  // to fit it nicely
  var fractions = c / segmentLength;
  var adjustedSegmentLength = Math.floor(fractions) % 2 === 0 ? c / Math.ceil(fractions) : c / Math.floor(fractions);

  // Calculate x, y deltas per segment
  var deltaX = adjustedSegmentLength * (a / c);
  var deltaY = adjustedSegmentLength * (b / c);

  var curX = xFrom,
    curY = yFrom;
  while (curX <= xTo && curY <= yTo) {
    doc.line(curX, curY, curX + deltaX, curY + deltaY);
    curX += 2 * deltaX;
    curY += 2 * deltaY;
  }
};

const multiLineText = (text, lineWidth) => {
  let result = [];
  if (text) {
    if (text.length > lineWidth) {
      let idx = text.substring(0, lineWidth).lastIndexOf(" ");
      result.push(text.substring(0, idx));
      result.push(text.substring(idx + 1));
    } else {
      result.push(text);
    }
  }
  return result;
};

const print2TableColumnWise = (doc, startY, header, data, tableWidth) => {
  let YAxis;
  if (data.length > 3) {
    let mid;
    mid = data.length % 2 === 0 ? parseInt(data.length / 2) : parseInt(data.length / 2) + 1;

    let autoTableOptions = {
      startY: startY + 7,
      body: data.slice(0, mid),
      columns: header,
      margin: { left: 7, right: 2 * 7 + tableWidth / 2 }
    };
    const options = { tableWidth: tableWidth / 2, minCharLen: 15, maxCharLen: 30 };

    addTable(doc, autoTableOptions, options);
    YAxis = doc.autoTable.previous.finalY;

    // Reset page to the same as before previous table
    let newPage = doc.internal.getCurrentPageInfo().pageNumber;

    doc.setPage(1 + doc.internal.getCurrentPageInfo().pageNumber - doc.autoTable.previous.pageCount);

    autoTableOptions = {
      startY: startY + 7,
      body: data.slice(mid, data.length),
      columns: header,
      margin: { left: 2 * 7 + tableWidth / 2, right: 7 }
    };

    addTable(doc, autoTableOptions, options);
    if (doc.internal.getCurrentPageInfo().pageNumber > newPage) {
      newPage = doc.internal.getCurrentPageInfo().pageNumber;
    }
    doc.setPage(newPage);
  } else {
    const autoTableOptions = { startY: startY + 7, body: data.slice(0, data.length), columns: header, margin: { left: 7, right: 107 } };
    const options = { tableWidth, minCharLen: 15, maxCharLen: 30 };

    addTable(doc, autoTableOptions, options);
    YAxis = doc.autoTable.previous.finalY;
  }
  return YAxis;
};

const delFields = ["destination", "deliveryDate", "delMode", "customerFlowRef", "flowRef"];
const getDelKey = flowInfo => delFields.map(field => flowInfo[field] || "").join("_");

const orderInfoData = (order, orderFlow) => {
  const flowInfoList = getCutOrderFlowInfoList(order, orderFlow);

  let columnList = [
    { dataKey: "bundleOrderNo", header: "Bundle Order No" },
    { dataKey: "poRef", header: "PO Ref" },
    { dataKey: "customerName", header: "Customer" },
    { dataKey: "productName", header: "Product" },
    { dataKey: "style", header: "Style Name" },
    { dataKey: "color", header: "Style Color" },
    { dataKey: "partName", header: "Part" },
    { dataKey: "destination", header: "Destination" },
    { dataKey: "deliveryDate", header: "Del. Date" },
    { dataKey: "deliveryMode", header: "Del. Mode" },
    { dataKey: "customerFlowRef", header: "BPO" },
    { dataKey: "flowRef", header: "Line ID" }
  ];

  //** Exclude Fields if value is empty in each flowInfo **//
  if (flowInfoList.every(fi => isEmpty(fi.styleNo))) {
    columnList = columnList.filter(c => c.dataKey !== "styleNo");
  }
  if (flowInfoList.every(fi => isEmpty(fi.destination))) {
    columnList = columnList.filter(c => c.dataKey !== "destination");
  }
  if (flowInfoList.every(fi => isEmpty(fi.deliveryDate))) {
    columnList = columnList.filter(c => c.dataKey !== "deliveryDate");
  }
  if (flowInfoList.every(fi => isEmpty(fi.delMode))) {
    columnList = columnList.filter(c => c.dataKey !== "deliveryMode");
  }
  if (flowInfoList.every(fi => isEmpty(fi.flowRef))) {
    columnList = columnList.filter(c => c.dataKey !== "flowRef");
  }
  if (flowInfoList.every(fi => isEmpty(fi.customerFlowRef))) {
    columnList = columnList.filter(c => c.dataKey !== "customerFlowRef");
  }

  const delKeys = getDistinctValues(flowInfoList.map(fi => getDelKey(fi)));

  const body = delKeys.map(delKey => {
    const fiList = flowInfoList.filter(fi => getDelKey(fi) === delKey);
    const flowInfo = fiList[0] || {};
    return {
      ...flowInfo,
      bundleOrderNo: orderFlow.bundleOrderNo,
      poRef: order.poRef,
      customerName: order.customer?.name,
      seasonName: order.season?.name,
      productName: getDistinctObjectValues(fiList.map(fi => fi.product))
        .map(p => p.name)
        .join(", "),
      style: getDistinctValues(fiList.map(fi => fi.style)).join(", "),
      styleNo: getDistinctValues(fiList.map(fi => fi.styleNo)).join(", "),
      color: getDistinctValues(fiList.map(fi => fi.color)).join(", "),
      partName: orderFlow.part,
      orderQty: flowInfo.orderQty,
      extra: flowInfo.extra
    };
  });

  return { columns: columnList, body };
};

const mergeRollList = rollList => {
  const rollMap = rollList.reduce(
    (acc, roll) => ({
      ...acc,
      [roll.rollId]: isEmpty(acc[roll.rollId]) ? [roll] : [...acc[roll.rollId], roll]
    }),
    {}
  );

  return Object.keys(rollMap).map(rollId => {
    const rollList = rollMap[rollId].sort((a, b) => a.start - b.start);
    return { ...rollList[0], start: rollList[0].start, end: rollList[rollList.length - 1].end };
  });
};
